import React, { Component } from 'react';
import { arrayIsNotEmpty, generateHierarchy } from "../../utils";

class Agent extends Component {
    render() {
        const { name } = this.props;
        return <li>{name}</li>;
    }
}

class Supervisor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false
        };
        this.toggleExpand = this.toggleExpand.bind(this);
    }

    toggleExpand() {
        this.setState(prevState => ({
            expanded: !prevState.expanded
        }));
    }

    render() {
        const { name, children } = this.props;
        const { expanded } = this.state;

        return (
            <li>
                <span className="cursor-pointer" onClick={this.toggleExpand}>{expanded ? '-' : '+'} {name}</span>
                {expanded && (<div style={{ margin: '0 30px' }}>
                    <ul>
                        {children.map(agent => (
                            <Agent key={agent.name} {...agent} />
                        ))}
                    </ul>
                </div>
                )}
            </li>
        );
    }
}

class Manager extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false
        };
        this.toggleExpand = this.toggleExpand.bind(this);
    }

    toggleExpand() {
        this.setState(prevState => ({
            expanded: !prevState.expanded
        }));
    }

    render() {
        const { name, children } = this.props;
        const { expanded } = this.state;

        return (
            <li>
                <span className="cursor-pointer" onClick={this.toggleExpand}>{expanded ? '-' : '+'} {name}</span>
                {expanded && (<div style={{ margin: '0 30px' }}>
                    <ul>
                        {children.map(supervisor => (
                            <Supervisor key={supervisor.name} {...supervisor} />
                        ))}
                    </ul>
                </div>
                )}
            </li>
        );
    }
}

class Division extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false
        };
        this.toggleExpand = this.toggleExpand.bind(this);
    }

    toggleExpand() {
        this.setState(prevState => ({
            expanded: !prevState.expanded
        }));
    }

    render() {
        const { name, children } = this.props;
        const { expanded } = this.state;

        return (
            <li>
                <span className="cursor-pointer" onClick={this.toggleExpand}>{expanded ? '-' : '+'} {name}</span>
                {expanded && (<div style={{ margin: '0 30px' }}>
                    <ul>
                        {children.map(manager => (
                            <Manager key={manager.name} {...manager} />
                        ))}
                    </ul>
                </div>
                )}
            </li>
        );
    }
}

class Site extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false
        };
        this.toggleExpand = this.toggleExpand.bind(this);
    }

    toggleExpand() {
        this.setState(prevState => ({
            expanded: !prevState.expanded
        }));
    }

    render() {
        const { name, children } = this.props;
        const { expanded } = this.state;

        return (
            <li>
                <span className="cursor-pointer" onClick={this.toggleExpand}>{expanded ? '-' : '+'} {name}</span>
                {expanded && (<div style={{ margin: '0 30px' }}>
                    <ul>
                        {children.map(manager => (
                            <Division key={manager.name} {...manager} />
                        ))}
                    </ul>
                </div>
                )}
            </li>
        );
    }
}

class List extends Component {
    render() {
        const { data } = this.props;

        return (
            <ul style={{ fontSize: '28px' }}>
                {data.map(site => (
                    <Site key={site.name} {...site} />
                ))}
            </ul>
        );
    }
}

class LayeredContent extends Component {

    render() {
        const
            {
                teamsHierarchy
            } = this.props;
        if (!arrayIsNotEmpty(teamsHierarchy)) {
            return <div></div>;
        }

        const result = generateHierarchy(teamsHierarchy);

        return <div><List data={result} /></div>;
    }
}

export default LayeredContent;
